import { unix } from 'dayjs';
import { get } from 'lodash-es';

import NextIcon from '@asset/next.icon.svg?react';
import { Row } from '@atom/grid/row/row';
import { BillingPlanEnum } from '@enum/billing-plan.enum';
import { DateFormatEnum } from '@enum/date-format.enum';
import { RouteEnum } from '@enum/route.enum';
import { useCreateCustomerPortalMutation } from '@hook/billing/billing.hooks';
import { useSubscription } from '@hook/billing/subscription.hook';
import { isExist } from '@util/data/is-exist';

import BillIcon from './assets/bill.icon.svg?react';
import CardIcon from './assets/card.icon.svg?react';
import EstimatedIcon from './assets/estimated.icon.svg?react';
import { ButtonNext, Col, TitleStat, TitleWrapper, Value, WrapperStats } from './plan-stats.style';

export const PlanStats = () => {
  const [createCustomerPortal] = useCreateCustomerPortalMutation();
  const subscription = useSubscription();

  const onManageSubscriptionClick = async () => {
    const result = await createCustomerPortal().unwrap();
    window.location.href = result.data.url;
  };

  const cancelAt = get(subscription, ['data', 'cancelAt']);
  const periodEnd = get(subscription, ['data', 'periodEnd']);
  const periodStart = get(subscription, ['data', 'periodStart']);
  const price = get(subscription, ['data', 'plan', 'price']);
  const type = get(subscription, ['data', 'plan', 'type']);
  const isBasePlan = get(subscription, ['data', 'plan', 'isBasePlan']);
  const platform = get(subscription, ['data', 'plan', 'platform']);

  const hasSubscriptionPlan = !isBasePlan && platform === BillingPlanEnum.Stripe;

  const isActive = isExist(periodStart);
  const isCanceled = isExist(periodEnd);

  return (
    <Row gutter={[16, 16]}>
      <Col span={8}>
        <WrapperStats>
          <BillIcon />
          <TitleWrapper>
            <TitleStat>{isCanceled ? 'Cancel date' : 'Renew date'}</TitleStat>
            <Value>
              {isCanceled
                ? unix(periodEnd).format(DateFormatEnum.Day)
                : isActive
                  ? unix(periodStart)
                      .add(1, type === 'monthly' ? 'month' : 'year')
                      .format(DateFormatEnum.Day)
                  : '-'}
            </Value>
          </TitleWrapper>
        </WrapperStats>
      </Col>
      <Col span={8}>
        <WrapperStats>
          <EstimatedIcon />
          <TitleWrapper>
            <TitleStat>Plan price</TitleStat>
            <Value>{price > 0 && !isCanceled ? `€ ${(price * (1 / 100)).toFixed(2)}` : '-'}</Value>
          </TitleWrapper>
        </WrapperStats>
        <ButtonNext href={RouteEnum.PaymentHistory.path} icon={<NextIcon />}>
          View payment history
        </ButtonNext>
      </Col>
      <Col span={8}>
        <WrapperStats>
          <CardIcon />
          <TitleWrapper>
            <TitleStat>{isCanceled ? 'Active to' : 'Started date'}</TitleStat>
            <Value>
              {isExist(cancelAt)
                ? unix(cancelAt).format(DateFormatEnum.Day)
                : isActive
                  ? unix(periodStart).format(DateFormatEnum.Day)
                  : '-'}
            </Value>
          </TitleWrapper>
        </WrapperStats>
        {hasSubscriptionPlan && (
          <ButtonNext icon={<NextIcon />} onClick={onManageSubscriptionClick}>
            Manage subscription
          </ButtonNext>
        )}
      </Col>
    </Row>
  );
};
